import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4100Model } from './kymw4100.model';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { OutputGoodsLayoutInspectListService } from './api-services/output-goods-layout-inspect-list.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

/**
 * 統一企画点検リスト設定クラス
 *
 * @export KYMW4100Component
 * @class KYMW4100Component
 */
@Component({
  selector: 'app-kymw4100',
  templateUrl: 'kymw4100.component.html',
  styleUrls: ['kymw4100.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW4100Component extends PlessViewHelperSub implements OnInit {

  // 画面部品参照
  @ViewChild('txi_OrderCode', { static: true }) public txi_OrderCode: OrderCodeTextInputComponent;

  // 親画面からの連携値
  param: any = null;

  kymw4100Model: KYMW4100Model = new KYMW4100Model();

  /** 生協コードマスタ */
  public coopData: Array<any> = null;

  /**
   *Creates an instance of KYMW4100Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {KYMW00Model} kymw00Model
   * @param {OutputGoodsLayoutInspectListService} outputGoodsLayoutInspectListService
   * @memberof KYMW4100Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    public kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public outputGoodsLayoutInspectListService: OutputGoodsLayoutInspectListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW4100Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4100';

    this.kymw4100Model.kymw4100Component = this;

    // 生協コード値のマップ
    this.coopData = [];
    this.coopData['chk_Ibaraki'] = this.kymw00Model.COOP_CODE_IB;
    this.coopData['chk_Tochigi'] = this.kymw00Model.COOP_CODE_TO;
    this.coopData['chk_Gunma'] = this.kymw00Model.COOP_CODE_GU;
    this.coopData['chk_Chiba'] = this.kymw00Model.COOP_CODE_TI;
    this.coopData['chk_Saitama'] = this.kymw00Model.COOP_CODE_SA;
    this.coopData['chk_Tokyo'] = this.kymw00Model.COOP_CODE_TK;
    this.coopData['chk_Nagano'] = this.kymw00Model.COOP_CODE_NA;
    this.coopData['chk_Niigata'] = this.kymw00Model.COOP_CODE_NI;

    this.initKYMW4100();
  }

  /**
   * 出力ボタンを押下した時に呼び出されるメソッド。
   *
   * @returns {void}
   * @memberof KYMW4100Component
   */
  public eventOutput_CLICKHandler(): void {
    if (this.inputCheck() === false) {
      return;
    }

    // パラメタ設定
    const vo = {
      orderCode: this.kymw4100Model.orderCode,
      mediumType: this.kymw4100Model.medium,
      startPageNum: this.kymw4100Model.startPageNum,
      endPageNum: this.kymw4100Model.endPageNum,
      inspectObject: this.kymw4100Model.radioGroup,
      mediumTypeTo: this.kymw4100Model.mediumTo,
      coopCodeList: []
    };

    // 会員生協
    vo.coopCodeList = [];

    if (this.kymw4100Model.ibaraki) {
      vo.coopCodeList.push(this.coopData['chk_Ibaraki']);
    }
    if (this.kymw4100Model.tochigi) {
      vo.coopCodeList.push(this.coopData['chk_Tochigi']);
    }
    if (this.kymw4100Model.gunma) {
      vo.coopCodeList.push(this.coopData['chk_Gunma']);
    }
    if (this.kymw4100Model.chiba) {
      vo.coopCodeList.push(this.coopData['chk_Chiba']);
    }
    if (this.kymw4100Model.saitama) {
      vo.coopCodeList.push(this.coopData['chk_Saitama']);
    }
    if (this.kymw4100Model.tokyo) {
      vo.coopCodeList.push(this.coopData['chk_Tokyo']);
    }
    if (this.kymw4100Model.nagano) {
      vo.coopCodeList.push(this.coopData['chk_Nagano']);
    }
    if (this.kymw4100Model.niigata) {
      vo.coopCodeList.push(this.coopData['chk_Niigata']);
    }

    // ファイル名の設定
    const fileName = '統一企画点検リスト_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.zip';
    // API呼び出し
    this.outputGoodsLayoutInspectListService.execute(this.kymw4100Model, vo, (data: any) => {
      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });

  }

  /**
   *  画面情報の初期化
   */
  public initKYMW4100(): void {
    // 受注コードをクリアに連動して、配達企画回（翌週）がクリア、媒体が再作成される。
    this.kymw4100Model.orderCode = '';
    // 会員生協
    this.kymw4100Model.allCoop = true;
    this.kymw4100Model.ibaraki = true;
    this.kymw4100Model.tochigi = true;
    this.kymw4100Model.gunma = true;
    this.kymw4100Model.chiba = true;
    this.kymw4100Model.saitama = true;
    this.kymw4100Model.tokyo = true;
    this.kymw4100Model.nagano = true;
    this.kymw4100Model.niigata = true;
    // 点検対象
    this.kymw4100Model.radioGroup = '1';
  }

  /**
   * メニュー「最新の情報に更新」押下時の処理
   *
   */
  public reloadKYMW4100(): void {
    this.initKYMW4100();
  }

  /**
   * 入力チェック
   *
   * @returns {boolean} true:OK false:NG
   * @memberof KYMW4100Component
   */
  public inputCheck(): boolean {
    // 受注コード必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw4100Model.orderCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['受注コード']);
      return false;
    }
    // 受注コード存在チェック
    if (PlessViewUtilsSub.isEmpty(this.txi_OrderCode.selectedCatalogID)) {
      this.dialogService.openAlertGetMessage('E0122', ['受注コード']);
      return false;
    }

    // 媒体区分
    // 媒体区分必須チェック
    if (!this.kymw4100Model.medium) {
      this.dialogService.openAlertGetMessage('E0103', ['媒体']);
      return false;
    }

    // 点検対象のチェック
    if (this.kymw4100Model.radioGroup === '2') {		// 「2：媒体間点検」の場合

      // 比較先媒体区分
      // 比較先媒体区分必須チェック
      if (!this.kymw4100Model.mediumTo) {
        this.dialogService.openAlertGetMessage('E0103', ['比較先媒体区分']);
        return false;
      }

      // 比較元媒体区分と比較先媒体区分のチェック
      if (this.kymw4100Model.mediumTo === this.kymw4100Model.medium) {						// 比較元媒体区分と比較先媒体区分が同じ場合

        this.dialogService.openAlertGetMessage('E0148', ['比較元と比較先で異なる媒体']);
        return false;
      }
    }

    // 会員生協必須チェック
    if (!this.kymw4100Model.ibaraki &&
      !this.kymw4100Model.tochigi &&
      !this.kymw4100Model.gunma &&
      !this.kymw4100Model.chiba &&
      !this.kymw4100Model.saitama &&
      !this.kymw4100Model.tokyo &&
      !this.kymw4100Model.nagano &&

      !this.kymw4100Model.niigata) {
      this.dialogService.openAlertGetMessage('E0103', ['会員生協']);
      return false;
    }
    // 会員生協選択数チェック
    let coopCount = 0;
    if (this.kymw4100Model.ibaraki) {
      coopCount = coopCount + 1;
    }
    if (this.kymw4100Model.tochigi) {
      coopCount = coopCount + 1;
    }
    if (this.kymw4100Model.gunma) {
      coopCount = coopCount + 1;
    }
    if (this.kymw4100Model.chiba) {
      coopCount = coopCount + 1;
    }
    if (this.kymw4100Model.saitama) {
      coopCount = coopCount + 1;
    }
    if (this.kymw4100Model.tokyo) {
      coopCount = coopCount + 1;
    }
    if (this.kymw4100Model.nagano) {
      coopCount = coopCount + 1;
    }
    if (this.kymw4100Model.niigata) {
      coopCount = coopCount + 1;
    }
    if (this.kymw4100Model.kuruco) {
      coopCount = coopCount + 1;
    }

    // 点検対象のチェック
    if (this.kymw4100Model.radioGroup === '1') {					// 「1：生協間点検」の場合

      if (coopCount === 1) {
        this.dialogService.openAlertGetMessage('E0148', ['２つ以上の会員生協']);
        return false;
      }
    }

    return true;
  }

  /**
   * 全生協選択の処理
   *
   */
  public eventAllCoop_CHANGEHandler(): void {
    this.kymw4100Model.ibaraki = this.kymw4100Model.allCoop;
    this.kymw4100Model.tochigi = this.kymw4100Model.allCoop;
    this.kymw4100Model.gunma = this.kymw4100Model.allCoop;
    this.kymw4100Model.chiba = this.kymw4100Model.allCoop;
    this.kymw4100Model.saitama = this.kymw4100Model.allCoop;
    this.kymw4100Model.tokyo = this.kymw4100Model.allCoop;
    this.kymw4100Model.nagano = this.kymw4100Model.allCoop;
    this.kymw4100Model.niigata = this.kymw4100Model.allCoop;
  }
}
